/* ═══════════════════════════════════════════════════════════════
   Harlowe Global JavaScript — Visual Layer Patch for Lorenza v6.3.0
   Namespaced under window.Harlowe to avoid Lorenza/PageFly conflicts.
   ═══════════════════════════════════════════════════════════════ */

(function() {
  'use strict';

  window.Harlowe = window.Harlowe || {};

  /* ─── Bilingual Toggle ─── */
  Harlowe.initLang = function() {
    var saved = localStorage.getItem('hw-lang') || 'en';
    document.documentElement.setAttribute('data-hw-lang', saved);
    Harlowe.updateLangButtons(saved);
  };

  Harlowe.toggleLang = function() {
    var current = document.documentElement.getAttribute('data-hw-lang') || 'en';
    var next = current === 'en' ? 'zh' : 'en';
    document.documentElement.setAttribute('data-hw-lang', next);
    localStorage.setItem('hw-lang', next);
    Harlowe.updateLangButtons(next);
  };

  Harlowe.updateLangButtons = function(lang) {
    var btns = document.querySelectorAll('.hw-lang-toggle');
    btns.forEach(function(btn) {
      btn.textContent = lang === 'en' ? '中文' : 'EN';
      btn.setAttribute('aria-label', lang === 'en' ? 'Switch to Chinese' : 'Switch to English');
    });
  };

  /* ─── IntersectionObserver Scroll Animations ─── */
  Harlowe.initScrollAnimations = function() {
    if (!('IntersectionObserver' in window)) {
      // Fallback: show all elements immediately
      document.querySelectorAll('.hw-fade-in-up').forEach(function(el) {
        el.classList.add('hw-visible');
      });
      return;
    }

    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          // Stagger children if they have data-hw-delay
          var delay = entry.target.getAttribute('data-hw-delay');
          if (delay) {
            entry.target.style.transitionDelay = delay + 's';
          }
          entry.target.classList.add('hw-visible');
          observer.unobserve(entry.target);
        }
      });
    }, {
      threshold: 0.1,
      rootMargin: '0px 0px -50px 0px'
    });

    document.querySelectorAll('.hw-fade-in-up').forEach(function(el) {
      observer.observe(el);
    });
  };

  /* ─── Hero Slideshow (BEM + Text Sync 修复版) ─── */
  Harlowe.initHeroSlideshow = function(containerId) {
    var container = document.getElementById(containerId || 'hw-hero');
    if (!container) return;

    var slides = container.querySelectorAll('.hw-hero__slide');
    var dots = container.querySelectorAll('.hw-hero__dot'); // 如果没报错，说明此 class 匹配
    // 【新增】：获取所有的文字内容块
    var texts = container.querySelectorAll('.hw-hero__slide-text');
    
    if (slides.length === 0) return;

    var current = 0;
    var total = slides.length;
    var interval = parseInt(container.getAttribute('data-interval')) || 6000;
    var timer;

    function showSlide(index) {
      // 1. 切换背景图片
      slides.forEach(function(s, i) {
        if (i === index) {
          s.classList.add('hw-hero__slide--active');
          s.style.opacity = '1';
        } else {
          s.classList.remove('hw-hero__slide--active');
          s.style.opacity = '0';
        }
      });
      
      // 2. 【新增】：同步切换文字内容
      /*
      texts.forEach(function(t, i) {
        if (i === index) {
          t.style.display = 'block'; // 显示当前文字
          t.style.opacity = '1';     // 如果有淡入淡出动画，确保透明度为1
        } else {
          t.style.display = 'none';  // 隐藏其他文字
          t.style.opacity = '0';
        }
      });
      */
     // 2. 同步切换文字内容（class 驱动，不再手改 display）
      texts.forEach(function(t, i) {
        if (i === index) {
          t.classList.add('hw-hero__slide-text--active');
          t.style.opacity = '1';
        } else {
          t.classList.remove('hw-hero__slide-text--active');
          t.style.opacity = '0';
        }
      });

      // 3. 切换底部指示点 (纯类名控制，移除冗余的内联样式)
      dots.forEach(function(d, i) {
        if (i === index) {
          d.classList.add('hw-hero__dot--active');
          // 清理掉之前可能残留的错误类名和内联样式
          d.classList.add('hw-active'); 
          d.style.width = '';
          d.style.background = '';
        } else {
          d.classList.remove('hw-hero__dot--active');
          d.classList.remove('hw-active');
          d.style.width = '';
          d.style.background = '';
        }
      });
      
      current = index;
    }

    function next() {
      showSlide((current + 1) % total);
    }

    function startAutoplay() {
      stopAutoplay(); 
      timer = setInterval(next, interval);
    }

    function stopAutoplay() {
      clearInterval(timer);
    }

    // 点击指示点切换
    dots.forEach(function(dot, i) {
      dot.addEventListener('click', function() {
        showSlide(i);
        startAutoplay();
      });
    });

    showSlide(0);
    startAutoplay();

    container.addEventListener('mouseenter', stopAutoplay);
    container.addEventListener('mouseleave', startAutoplay);
  };

  /* ─── YouTube Lazy Embed ─── */
  Harlowe.initYouTubeEmbed = function() {
    // 将原来的 '.hw-video-wrap[data-yt-id]' 
    // 改为 '.hw-brand-film__player[data-hw-youtube]'
    document.querySelectorAll('.hw-brand-film__player[data-hw-youtube]').forEach(function(wrap) {
      wrap.addEventListener('click', function() {
        var ytId = wrap.getAttribute('data-hw-youtube'); // 这里也要改
        // ... 后面的逻辑保持不变
        if (!ytId) return;
        var iframe = document.createElement('iframe');
        iframe.setAttribute('src', 'https://www.youtube.com/embed/' + ytId + '?autoplay=1&rel=0');
        iframe.setAttribute('frameborder', '0');
        iframe.setAttribute('allow', 'autoplay; encrypted-media');
        iframe.setAttribute('allowfullscreen', '');
        iframe.style.position = 'absolute';
        iframe.style.inset = '0';
        iframe.style.width = '100%';
        iframe.style.height = '100%';
        wrap.innerHTML = '';
        wrap.style.position = 'relative';
        wrap.appendChild(iframe);
      });
    });
  };

  /* ─── Navbar Scroll Effect ─── */
  Harlowe.initNavbar = function() {
    var navbar = document.querySelector('.hw-navbar');
    if (!navbar) return;

    var threshold = 50;
    var ticking = false;

    function onScroll() {
      if (!ticking) {
        window.requestAnimationFrame(function() {
          if (window.scrollY > threshold) {
            navbar.classList.add('hw-scrolled');
          } else {
            navbar.classList.remove('hw-scrolled');
          }
          ticking = false;
        });
        ticking = true;
      }
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll(); // Initial check
  };

  /* ─── Mobile Menu ─── */
  Harlowe.initMobileMenu = function() {
    var toggleBtn = document.querySelector('.hw-hamburger');
    var menu = document.querySelector('.hw-mobile-menu');
    var closeBtn = document.querySelector('.hw-mobile-close');
    if (!toggleBtn || !menu) return;

    toggleBtn.addEventListener('click', function() {
      menu.classList.toggle('hw-open');
      document.body.style.overflow = menu.classList.contains('hw-open') ? 'hidden' : '';
    });

    if (closeBtn) {
      closeBtn.addEventListener('click', function() {
        menu.classList.remove('hw-open');
        document.body.style.overflow = '';
      });
    }

    // Close on link click
    menu.querySelectorAll('a').forEach(function(link) {
      link.addEventListener('click', function() {
        menu.classList.remove('hw-open');
        document.body.style.overflow = '';
      });
    });
  };

  /* ─── Count-Up Animation ─── */
  Harlowe.countUp = function(el, target, duration) {
    if (!el) return;
    var start = 0;
    var startTime = null;

    function step(timestamp) {
      if (!startTime) startTime = timestamp;
      var progress = Math.min((timestamp - startTime) / duration, 1);
      var value = Math.floor(progress * target);
      el.textContent = value;
      if (progress < 1) {
        window.requestAnimationFrame(step);
      } else {
        el.textContent = target;
      }
    }

    window.requestAnimationFrame(step);
  };

  /* ─── Product Gallery (for product page) ─── */
  Harlowe.initProductGallery = function() {
    var mainImg = document.querySelector('.hw-product-gallery__main img');
    var thumbs = document.querySelectorAll('.hw-product-gallery__thumb');
    if (!mainImg || thumbs.length === 0) return;

    thumbs.forEach(function(thumb) {
      thumb.addEventListener('click', function() {
        var src = thumb.querySelector('img').getAttribute('data-full-src') ||
                  thumb.querySelector('img').src;
        mainImg.src = src;
        thumbs.forEach(function(t) { t.classList.remove('hw-active'); });
        thumb.classList.add('hw-active');
      });
    });
  };

  /* ─── Cart Quantity Buttons ─── */
  Harlowe.initCartQuantity = function() {
    document.querySelectorAll('.hw-quantity').forEach(function(wrap) {
      var input = wrap.querySelector('.hw-quantity__input');
      var minus = wrap.querySelector('.hw-quantity__btn--minus');
      var plus = wrap.querySelector('.hw-quantity__btn--plus');
      if (!input) return;

      if (minus) {
        minus.addEventListener('click', function() {
          var val = parseInt(input.value) || 1;
          if (val > 1) {
            input.value = val - 1;
            input.dispatchEvent(new Event('change', { bubbles: true }));
          }
        });
      }
      if (plus) {
        plus.addEventListener('click', function() {
          var val = parseInt(input.value) || 1;
          input.value = val + 1;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      }
    });
  };

  /* ─── Init All ─── */
  Harlowe.init = function() {
    Harlowe.initLang();
    Harlowe.initScrollAnimations();
    Harlowe.initNavbar();
    Harlowe.initMobileMenu();
    Harlowe.initYouTubeEmbed();
    Harlowe.initProductGallery();
    Harlowe.initCartQuantity();

    // --- 新增：初始化轮播图 ---
    Harlowe.initHeroSlideshow('hw-hero');
  };

  // Run on DOMContentLoaded
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', Harlowe.init);
  } else {
    Harlowe.init();
  }

})();
